import * as React from 'react';
import { FindAPDPaginationModel } from '../../redux/reducers/pagination-reducer';
import { FindAPDSettingsModel } from '../../redux/reducers/find-a-pd-settings';
import { FindAPDAppState } from "../../classes/redux-states";
import { Dispatch, connect } from "react-redux";
import { setPage } from "../../redux/actions/actions";
import { PagingArrows } from "./paging-arrows";
import { Paging } from "./paging";

export interface StateToProps {
    pagination: FindAPDPaginationModel;
    settings: FindAPDSettingsModel;
    totalPages: number;
    totalDentists: number;
}

export interface DispatchToProps {
    setCurrentPage (page: number): any;
}


type PaginationProps = DispatchToProps & StateToProps;


export class PaginationComponent extends React.Component<PaginationProps, any> {
    constructor(props: PaginationProps) {
        super(props);
    }



    render() {
        return (
            <div className="pagination-container">
                <PagingArrows paging={this.props.pagination} isLeftArrows={true} onPageSelect={this.props.setCurrentPage} totalDentists={this.props.totalDentists} totalPages={this.props.totalPages} />

                <div className="pagination-desktop">
					<Paging totalPages={this.props.totalPages} paging={this.props.pagination} onPageSelect={this.props.setCurrentPage} numberOfButtonsToShow={8} />
                </div>

                <div className="pagination-mobile">
					<Paging paging={this.props.pagination} totalPages={this.props.totalPages} onPageSelect={this.props.setCurrentPage} numberOfButtonsToShow={5} />
                </div>

				<PagingArrows paging={this.props.pagination} isLeftArrows={false} onPageSelect={this.props.setCurrentPage} totalDentists={this.props.totalDentists} totalPages={this.props.totalPages} />
            </div>
        );
    }
}

function mapStateToProps(state: FindAPDAppState): StateToProps {
    return {
        pagination: state.findAPDPaginationModel,
        settings: state.findAPDSettingsModel,
        totalPages: state.findAPDApiModel.totalPages,
        totalDentists: state.findAPDApiModel.totalDentists
    }
}

function mapDispatchToProps(dispatch: Dispatch<FindAPDAppState>): DispatchToProps {
    return {
		setCurrentPage: (currentPage: number) => dispatch(setPage(currentPage))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginationComponent)


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/findapd/components/pagination/pagination.tsx